import { render, staticRenderFns } from "./Notibar.vue?vue&type=template&id=084b603a&scoped=true&"
import script from "./Notibar.vue?vue&type=script&lang=ts&"
export * from "./Notibar.vue?vue&type=script&lang=ts&"
import style0 from "./Notibar.scss?vue&type=style&index=0&id=084b603a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_1f9b6d6a8c5e3033a639476f0cf6d876/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084b603a",
  null
  
)

export default component.exports